import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'
import setCookie from '@src/quince-site-common/src/utils/setCookie'

import { IMPACT_CLICK_ID_COOKIE_EXPIRY_IN_MINUTES } from '../integrations/Impact'

const HEADERS = {
  IMPACT_CLICK_ID: 'x-sgtm-impact-click-id',
}

const processResponseHeaders = (headers?: Record<string, string>): void => {
  try {
    if (!headers || typeof headers !== 'object') {
      return
    }

    const impactClickId = headers[HEADERS.IMPACT_CLICK_ID] ?? ''
    if (impactClickId) {
      setCookie(ANALYTIC_COOKIES.IMPACT_CLICK_ID, impactClickId, IMPACT_CLICK_ID_COOKIE_EXPIRY_IN_MINUTES)
    }
  } catch (error) {
    console.error('Error processing response headers SGTM API', error)
    captureException('Error processing response headers SGTM API', {
      module: MODULES.SERVER_PIXEL,
      feature: FEATURES.SERVER_PIXEL_API,
      extraInfo: {
        capturedFrom: 'Process response headers in SGTM API',
        errorDetail: JSON.stringify(error),
      },
    })
  }
}

export { processResponseHeaders }
